<template>
    <div v-if="offline" class="offline-status">Lost realtime connection...</div>
</template>

<script>
export default {
    name: 'OfflineStatus',

    data: () => ({
        offline: null,
    }),

    mounted() {
        this.$echo.connector.pusher.connection
            .bind('connected', () => {
                if (this.offline === true) {
                    this.$store.dispatch('Conversation/fetchMessages');
                }

                this.offline = false;
            })
            .bind('unavailable', () => {
                this.offline = true;
            })
            .bind('connecting', status => {
                if (!status) {
                    this.offline = true;
                }
            });
    },
};
</script>

<style lang="scss" scoped>
@import 'resources/scss/toolbox.scss';

.offline-status {
    position: relative;
    display: block;
    width: 100%;
    background-color: $danger;
    color: $danger-invert;
    padding: $column-gap;
    font-size: $small-font-size;
    background-clip: padding-box;
    margin-bottom: 0 !important;
}
</style>
